import { Box } from "@mui/material";
import CultureForm from "../components/forms/cultureForm.component";
import { useDispatch, useSelector } from "react-redux";
import { createCultureStart } from "../store/features/culture/cultureSlice";
import CustomAlert from "../components/alert/alert.component";
import { getErrorMessage } from "../utils/errorUtils";

const AddCulturePage = () => {
  const dispatch = useDispatch();

  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const { isLoading, error, success } = useSelector((state) => state.culture);

  const defaultValues = {
    name: "",
  };

  const onSubmit = (data) => {
    dispatch(createCultureStart({ data, accessToken: accessToken }));
  };
  return (
    <Box width="100%">
      {error && (
        <CustomAlert
          severity="error"
          message={getErrorMessage(error, {
            fallback: "Errore durante la creazione della coltura.",
            messages: {
              error_generic_400: "La coltura inserita è già presente.",
            },
          })}
        />
      )}
      <CultureForm
        mode="create"
        onSubmit={onSubmit}
        isLoading={isLoading}
        error={error}
        success={success}
        defaultValues={defaultValues}
      />
    </Box>
  );
};

export default AddCulturePage;
